import * as React from 'react';
import './SignUpFormContainer.css';
import {Context} from '../../state/Store';
import TermsOfUseComponent from '../TermsOfUse/TermsOfUseComponent';
import RedwoodInputText from '../../common/Input/RedwoodInputText';
import RedwoodSelect from '../../common/Select/RedwoodSelect';
import Icon from '../../common/Icon/Icon';
import * as _ from 'lodash';
import countries from '../../data/CountriesInfo';
import { generateRandomNumber, getOrgId, timer } from '../Helpers';
import {base_url, signup_environment} from '../../config/apiConfig';
import {regExp} from '../Validators';
import PromoDialog from '../Dialogs/PromoDialog/PromoDialog';
import PasswordComponent from '../Password/PasswordComponent';
import {useTranslation, Trans} from "react-i18next";
import promotionsData from '../../data/PromotionsInfo';
import Notifier from '../../common/Notifier/Notifier';
import i18next from 'i18next';
import SendAction from '../../CourierService/SendAction';
import SendLogs from '../../CourierService/SendLogs';
import SendMetrics from '../../CourierService/SendMetrics';
import * as Bowser from "bowser";
import {navTrack} from '../../config/adobeAnalytics';
import RedwoodModal from '../../common/Modal/RedwoodModal';
import Button from '../../common/Button/Button';


const SignUpFormContainer = (props) => {
  const {sourceType, referrer, programType, verifyEmailToken} = props;
  const {t} = useTranslation();
  const [state, dispatch] = React.useContext(Context);
  const errorState = {isValid: true, value: '', errorMsg: ''};
  const [error, setError] = React.useState({email:errorState, accountName:errorState, organization:errorState, firstName:errorState, lastName: errorState, altEnglishCompanyName: errorState});
  const [accountList, setAccountList] = React.useState({exist: false, clicked: false, status: false});
  const [touched, setTouched] = React.useState({});
  const [passwordError, setPasswordError] = React.useState({passwordValid: null, matchPassword: null});
  const [accountName, setAccountName] = React.useState('');
  const [invalid, setInvalid] = React.useState(false); //Country Field
  const [loading, setLoading] = React.useState(false);
  const [verifyEmailLoading, setVerifyEmailLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [sendEmail, setSendEmail] = React.useState(false);
  const [counter, setCounter] = React.useState(0);
  const [verifyEmailCount, setVerifyEmailCount] = React.useState(0);
  const [maxAttemptsError, setMaxAttemptsError] = React.useState(false);
  const accountNameLength = 25;
  const [bannerLevel, setBannerLevel] = React.useState('');
  const [bannerTitle, setBannerTitle] = React.useState('');
  const [bannerMessage, setBannerMessage] = React.useState('');
  const [accntNameRetries, setAccntNameRetries] = React.useState(0);
  const [recurseAccntNameRetries, setRecurseAccntNameRetries] = React.useState(0);
  const [taggedEmailInfo, setTaggedEmailInfo] = React.useState('');
  const [verifyEmailBtnClicked, setVerifyEmailBtnClicked] = React.useState(0);

  const canContinue = () => {
    let flag = false;
    _.forIn(touched, function(value, key) {
      if(value === true) {
        flag =  true;
      }
    });

    const deptNameFlag = state.country === 'JP' ? state.departmentName !== '' : state.departmentName === '';
    const altEnglishCompanyNameFlag = (state.country === 'JP' || state.country === 'CN' || state.country === 'TW' || state.country === 'KR') && state.companyName !== ''?
    state.altEnglishCompanyName !=='' : state.altEnglishCompanyName === ''; 

    return flag ? true : !(state.country !== '' 
      && (error.email.value !== ''  || state.email !== '')
      && error.accountName.isValid
      && (error.firstName.value !== '' || state.firstName !== '')
      && (error.lastName.value !== '' || state.lastName !== '')
      && (error.organization.isValid || state.companyName !== '')
      && !(_.isEmpty(state.homeRegion))
      && passwordError.passwordValid
      && passwordError.matchPassword
      && deptNameFlag
      && (altEnglishCompanyNameFlag && error.altEnglishCompanyName.isValid)
    );
  };

  const canVerifyEmail = () => {
    let flag = false;
    _.forIn(touched, function(value, key) {
      if(value === true) {
        flag =  true;
      }
    });

    return verifyEmailCount >= 3 ? true : flag ? true : !(state.country !== '' 
    && error.email.isValid && (error.firstName.value !== '' || state.firstName !== '')
    && (error.lastName.value !== '' || state.lastName !== '') && !verifyEmailLoading && !loading)
  }
  const countriesList = () => {
    var keys = [];

    Object.keys(countries.countries).forEach (function(item) {
      keys.push({"value":item, "label": t('countries.' + item)});
    })

    keys.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
    return keys;
  }

  // Countdown timer
  React.useEffect(() => {
    let isSubscribed = true;
    if(state.sendEmail === true) {
      const timer = isSubscribed ? counter > 0 && setInterval(() => setCounter(counter - 1), 1000) : null;
      if(verifyEmailCount === 3 && counter === 1) {
        setMaxAttemptsError(true);
      }
      return () => clearInterval(timer);
    }
    return () => (isSubscribed = false);
  }, [counter]);

  const checkBanner = (bannerStartTime, bannerEndTime) => {
    const currentTime = new Date().getTime();
    if (currentTime >= bannerStartTime && currentTime <= bannerEndTime) {
      dispatch({
        type: "UPDATE_SHOW_BANNER",
        payload: true,
      });
      if (document.getElementById("main").classList.contains("modal-open")) {
        document.getElementById("main").classList.remove("modal-open");
      } else {
        document.getElementById("main").classList.add("modal-open");
      }
    }
  };

  const setApiError = () => {
    dispatch({
      type:'UPDATE_APIERROR',
      payload: true
    });
  };

  const emailVerification = (flag) => {
    setVerifyEmailLoading(flag);
  }

  //Store SourceType and Referrer in global state
  React.useEffect(() => {
    dispatch({
      type: "UPDATE_BASIC_DETAILS",
      payload: [sourceType, referrer, i18next.language]
    })
  }, [sourceType]);

  //To select the default promo from promotionsData
  React.useEffect(() => {
    promotionsData.items.filter(function(promoDefinition) {
      if(_.toUpper(programType) === 'STARTUP') {
        if(promoDefinition.programType === 'STARTUP') {
          dispatch({
            type: "UPDATE_DEFAULT_PROMO",
            payload: promoDefinition
          })
        }
      }
      else {
        if(promoDefinition.default) {
          dispatch({
            type: "UPDATE_DEFAULT_PROMO",
            payload: promoDefinition
          })
        }
      }
    })
  }, [promotionsData])

  //Browser, OS and Platform Metrics
  React.useEffect(() => {

    //Browser
    const browserName = Bowser.name;
    Bowser.name === 'Chrome' && SendMetrics({name: 'Chrome.Count.Metrics', value:1, userSession: state.user_session});
    Bowser.name === 'Safari' && SendMetrics({name: 'Safari.Count.Metrics', value: 1, userSession: state.user_session});
    Bowser.name === 'Firefox' && SendMetrics({name: 'Firefox.Count.Metrics', value: 1, userSession: state.user_session});
    Bowser.name === 'Microsoft Edge' && SendMetrics({name: 'Edge.Count.Metrics', value: 1, userSession: state.user_session});
    Bowser.name === 'Internet Explorer' && SendMetrics({name: 'IE.Count.Metrics', value: 1, userSession: state.user_session});
    const isUnknownBrowser = browserName !== 'Chrome' && browserName !== 'Safari' && browserName !== 'Firefox' && browserName !== 'Microsoft Edge' && browserName !== 'Internet Explorer';
    isUnknownBrowser && SendMetrics({name: 'Unknown.Count.Metrics', value: 1, userSession: state.user_session});

    //OS
    Bowser.osname === 'macOS' && SendMetrics({name: 'Mac.Count.Metrics', value: 1, userSession: state.user_session});
    Bowser.osname === 'Linux' && SendMetrics({name: 'Linux.Count.Metrics', value: 1, userSession: state.user_session});
    Bowser.osname === 'Windows' && SendMetrics({name: 'Windows.Count.Metrics', value: 1, userSession: state.user_session});

    //Platform
    let platform = 'Desktop';
    if (Bowser.mobile) {
      platform = 'Mobile';
    } else if (Bowser.tablet) {
      platform = 'Tablet';
    }

    SendMetrics({name: `${platform}.Count.Metrics`, value: 1, userSession: state.user_session});

  }, [state.render]);

  React.useEffect(() => {
    if(!_.isEmpty(verifyEmailToken)) {
      fetch(
        `${base_url}/email/verifyEmail?token=${verifyEmailToken}`,
        {
          method: 'GET',
          headers: {'Content-Type': 'application/json'}
        } 
      ).then(async res => {
        navTrack("oci-signup", state.language, "s1-verification-link-clicked", "verify-email-token");
        if(res.status === 200) {
          const result = await res.json();
          SendMetrics({name: "VerifyEmail.Count.Metrics.Success", value:1, userSession: result.userSessionId});
          SendLogs({severity: 20000, message: "GET VerifyEmailToken API successful, EmailID:"+result.email, userSession: result.userSessionId});
          dispatch({type: 'VERIFY_EMAIL_TOKEN', payload: result.token});
          dispatch({type: 'UPDATE_NAME', payload: result.email});
          dispatch({type: 'UPDATE_LAST_NAME', payload: result.lastName});
          dispatch({type: 'UPDATE_FIRST_NAME', payload: result.firstName});
          dispatch({type: 'UPDATE_USER_SESSION', payload: result.userSessionId});

          const countryId = result.country;
          const countryObject = {'value': countryId, label: t('countries.' + countryId)};
          const countryInfo = countries.countries[countryId];
          if(countryInfo === undefined) {
            setInvalid(true)
            dispatch({
              type: 'UPDATE_COUNTRY',
              payload: ['', countryObject, {}, '', '']
            });
          } else {
            const orgId = getOrgId(countryInfo.tc.OrgName);
            
            setInvalid(false)
            dispatch({
              type: 'UPDATE_COUNTRY',
              payload: [countryId, countryObject, countryInfo, orgId]
            });
          }
          const name = _.split(result.email, '@', 1);
          const accName = name[0].replace(/[^a-zA-Z0-9]/g, "");
          setAccountName((accName.toLowerCase()).substr(0,24));
          navTrack("oci-signup", state.language, "s1-verify-email-token", "email-token-valid");
        } else if(res.status >= 400) {
          toggleModal();
          SendMetrics({name:"VerifyEmail.Count.Metrics.Error", value:1, userSession:state.user_session});
          SendLogs({severity: 40000, message: "GET VerifyEmailToken API Failure, EmailID:"+state.username, userSession:state.user_session});
          navTrack("oci-signup", state.language, "s1-email-token-expired", "user-clicked-on-link-after-10-mins");
        }
        SendMetrics({name: 'VerifyEmail.Count.Metrics', value:1, userSession: state.user_session});
      }).catch(error => {
        console.log(error);
      })
    }
    
  },[verifyEmailToken]);

  //GET sendAssociatedAccountsByEmail
  React.useEffect(() => {
    if(accountList.exist === true) {
      fetch(
        `${base_url}/sendAssociatedAccountsByEmail?email=${encodeURIComponent(state.username)}`,
        {
          method: 'GET',
          headers: {'Content-Type': 'application/json'}
        }
      )
      .then(res => {
        if(res.status === 204) {
          setAccountList(list => {
            return {...list, status: true}
          });
        }
        SendLogs({severity: 20000, message: "GET sendAssociatedAccountsByEmail successful", userSession:state.user_session});
        SendMetrics({name:"SendAssociatedAccountsByEmail.Count.Metrics", value:1, userSession:state.user_session});
      }).catch(error => {
        console.log(error);
        SendLogs({severity: 40000, message: "GET sendAssociatedAccountsByEmail error: " + error.message, userSession:state.user_session});
        SendMetrics({name:"SendAssociatedAccountsByEmail.Count.Metrics.Fail", value:1, userSession:state.user_session});
      })
    }
  },
  [accountList.clicked]
  );


  //GET Home regions list
  React.useEffect(() => {
    fetch(
      `${base_url}/region`,
      {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      }
    ).then(async res => {
      if(res.status === 200) {
        const result = await res.json();
        let list = [];
        result.items.map(homeRegion => {
          const subList = homeRegion.homeRegions.map(subRegion => {
            return({label: subRegion.regionName, value: {id: subRegion.id}, group: homeRegion.id});
          });
          const dataRegion = {label: homeRegion.regionName,value: homeRegion.id, options: subList}

          list = list.concat(dataRegion);
        });
        if( signup_environment === 'dev' || signup_environment === 'miglab') {
          const homeRegionList = [{label: 'North America', options: [{label: 'US Dev West (Seattle)', value: {id: 'us-seattle-1'}, group: 'NORTH_AMERICA_REGION'}]}];
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: homeRegionList
          })
        } else if(signup_environment === 'pool2') {
          const homeRegionList = [{label: 'North America', options: [{label: 'US Dev West (Seattle)', value: {id: 'us-seattle-1'}, group: 'APAC_REGION'}]}];
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: homeRegionList
          })
        } else if(signup_environment === 'pintlab') {
          const homeRegionList = [{label: 'North America', options: [{label: 'US Dev West (Seattle)', value: {id: 'us-seattle-1'}, group: 'NORTH_AMERICA_REGION1'}]}];
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: homeRegionList
          })
        }
        else {
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: list
          })
        }
      }
      if(res.status >= 400) {
        SendMetrics({name:"Region.Count.Metrics.Error", value:1, userSession:state.user_session});
        setApiError();
      }
      SendLogs({severity: 20000, message: "GET Home regions list successful", userSession:state.user_session});
      SendMetrics({name:"Region.Count.Metrics", value:1, userSession:state.user_session});
    }).catch(error => {
      console.log(error);
      SendLogs({severity: 40000, message: "GET Home regions list error: " + error.message, userSession:state.user_session});
      SendMetrics({name:"Region.Count.Metrics.Fail", value:1, userSession:state.user_session});
    })

  }, [state.render])
 

  //GET banner
  React.useEffect(() => {
    fetch(
      `${base_url}/banner`,
      {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      }
    ).then(async res => {
      if(res.status === 200) {
          const result = await res.json();
          const banner = result.items[0];
          setBannerLevel(banner.level);
          setBannerTitle(banner.bannerTitle);
          setBannerMessage(banner.bannerDetails);
          
          checkBanner(Date.parse(banner.startTime), Date.parse(banner.endTime));
      }
      if(res.status >= 400) {
        SendMetrics({name:"Banner.Count.Metrics.Error", value:1, userSession:state.user_session});
      }
      SendLogs({severity: 20000, message: "GET banner list successful", userSession:state.user_session});
      SendMetrics({name:"Banner.Count.Metrics", value:1, userSession:state.user_session});
    }).catch(error => {
      console.log(error);
      SendLogs({severity: 40000, message: "GET banner list error: " + error.message, userSession:state.user_session});
      SendMetrics({name:"Banner.Count.Metrics.Fail", value:1, userSession:state.user_session});
    })
  }, [state.render])

  //Recursively validate cloud account name until it is unique
  React.useEffect(() => {
    if(accountName !== '') {
      fetch(
        `${base_url}/validateAccountName`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({"name": accountName})
        }
      )
      .then(async res => {
        if(res.status === 204) {
          dispatch({
            type: "UPDATE_ACC_NAME",
            payload: accountName
          });
          SendLogs({severity: 20000, message: "POST Recursively validate cloud account name successful", userSession:state.user_session});
          SendMetrics({name:"ValidateAccountName.Count.Metrics", value:1, userSession:state.user_session});
        }
        let trimAccountName;
        if(res.status === 400) {
          if(accountName.length > accountNameLength-2){
            trimAccountName = accountName.substr(0,24);
            setAccountName(trimAccountName);
          }
        }
        if(res.status === 409) {
          SendMetrics({name:"ValidateAccountName.Count.Metrics.Duplicate", value:1, userSession:state.user_session});
          const random = generateRandomNumber(1, 100);
          if(accountName.length > accountNameLength-2){
            trimAccountName = accountName.substr(0,22);
            setAccountName(trimAccountName + random);
          }else {
            setAccountName(accountName + random);
          }
        } else if(res.status >= 500){
          SendMetrics({name:"ValidateAccountName.Count.Metrics.Error", value:1, userSession:state.user_session});
          if(recurseAccntNameRetries === 3){
            setApiError();
          } else{
            setRecurseAccntNameRetries(recurseAccntNameRetries + 1);
          }
        }
      }).catch(error => {
        console.log(error);
        SendLogs({severity: 40000, message: "POST Recursively validate cloud account name error: " + error.message, userSession:state.user_session});
        SendMetrics({name:"ValidateAccountName.Count.Metrics.Fail", value:1, userSession:state.user_session});
      })
    } 
  }, [accountName, recurseAccntNameRetries]);

  //POST validate account name - When user modifies the Cloud account name 
  React.useEffect(() => {
    if(error.accountName.isValid && state.accountName !== '' && state.accountName.length <= 25) {
      fetch(
        `${base_url}/validateAccountName`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({"name": state.accountName})
        }
      )
      .then(async res => {
        
        if(res.status === 409) {
          const result = await res.json();
          setError(error => {
            return {...error, ...{accountName: {isValid: false, value: '', errorMsg: result.message}}}
          });
        } else if(res.status === 400) {
          const result = await res.json();
          if(_.startsWith(result.message, 'Cloud account name is invalid')) {
            setError(error => {
              return {...error, ...{accountName: {isValid: false, value: '', errorMsg: result.message}}}
            });
          }
        } else if(res.status >= 500){
          SendMetrics({name:"ValidateAccountName.Count.Metrics.Error", value:1, userSession:state.user_session});
          if(accntNameRetries === 3){
            setApiError();
          } else{
            setAccntNameRetries(accntNameRetries + 1);
          }
          
        }
        SendLogs({severity: 20000, message: "POST validate account name successful", userSession:state.user_session});
        SendMetrics({name:"ValidateAccountName.Count.Metrics", value:1, userSession:state.user_session});
        
      }).catch(error => {
        console.log(error);
        SendLogs({severity: 40000, message: "POST validate account name error: " + error.message, userSession:state.user_session});
        SendMetrics({name:"ValidateAccountName.Count.Metrics.Fail", value:1, userSession:state.user_session});
      })
    }else if (state.accountName !== '' && state.accountName.length > accountNameLength){
        setError(error => {
          return {...error, ...{accountName: {isValid: false, value: '', errorMsg: <Trans i18nKey='signup.accountNameLengthError'>Account Name cannot be more than 25 characters</Trans>}}}
        });
      }},
    [error.accountName.value, accntNameRetries]
  );

  const updateTouched = (name, value) => {
    setTouched(touched => {
      return{...touched, ...{[name]: value}}
    });
  };

  const passwordErrorFlag = (name, value) => {
    setPasswordError(passwordError => {
      return{...passwordError, ...{[name]: value}}
    });
  };

  const updateEmailError = (emailFlag, value, msg) => {
    setError(error => {
      return {...error, ...{email: {isValid: emailFlag, value: value, errorMsg: msg}}}
    });
  }

  const resetError = (name) => {
    setError(error => {
      return {...error, ...{[name]: errorState}}
    });
  }
  const sendVerificationLink = () => {
    setSendEmail(true);
    setVerifyEmailCount(verifyEmailCount + 1);
  }
  //Create Cloud Account Name based upon username
  const updateAccountName = () => {
      const name = _.split(state.username, '@', 1);
      const accName = name[0].replace(/[^a-zA-Z0-9]/g, "");
      setAccountName(accName.toLowerCase().substr(0,24));
  }

  const updateSETrialAccountName = (companyname) => {
    setAccountName(companyname.toLowerCase().replace(/[^a-zA-Z0-9]/g,'').substr(0,24));
  }

  const updateAccountListing = (exist, clicked, status) => {
    setAccountList(list => {
      return {...list, exist: exist, clicked: clicked, status: status}
    });
  }

  const onChangeHandler = (e, action, payload) => {
    dispatch({
      type:`${action}`,
      payload: payload
    });
    setTouched({...touched, [e.target.name]: true})
  }

  const onEmailChange = (e, action, payload, pattern) => {
    let val = _.trim(e.target.value);
    const name = e.target.name;
    const translatedName = t('signup.'+name);
    dispatch({
      type:`${action}`,
      payload: val
    });

    if(verifyEmailBtnClicked >= 1) {
      if(val.length === 0) {
        setError(error => {
          return {...error, ...{[name]: {isValid: false, value: '', errorMsg: <Trans i18nKey='personalInfo.requiredMsg'>A value for {translatedName} is required.</Trans>}}}
        });
      } else if(!val.match(pattern) || val === '') {
        setError(error => {
          return {...error, ...{[name]: {isValid: false, value: '', errorMsg: t('regExpr.email') }}}
        });
      } else {
        setError(error => {
          return {...error, ...{[name]: {isValid: true, value: val, errorMsg: ''}}}
        });
      }
      
    }
  }

  const onBlurHandler = (e, pattern, action) => {
    let val = _.trim(e.target.value);
    const name = e.target.name;
    dispatch({type: `${action}`, payload: val});
    const translatedName = t('signup.'+name);
  
    setTouched({...touched, [e.target.name]: false})
    SendAction({action:'input_'+name, value:val, userSession:state.user_session});

    if(val.length === 0) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: <Trans i18nKey='personalInfo.requiredMsg'>A value for {translatedName} is required.</Trans>}}}
      });
    } else if(!val.match(pattern) || val === '') {
      navTrack("oci-signup", state.language, "s1-entered-" + `${name}`, "invalid-"+ `${name}`);
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: t('regExpr.' + name)}}}
      });
    } else {
      if(name === 'email') {
        const plusIndex = val.indexOf('+');
        const domainIndex = val.indexOf('@');
        if(plusIndex !== -1) {
          val = val.substring(0, plusIndex) + val.substring(domainIndex, val.length);
          dispatch({type: 'UPDATE_NAME', payload: val});
          setTaggedEmailInfo(t('signup.taggedEmailInfo'));
        }
      }
      navTrack("oci-signup", state.language, "s1-entered-" + `${name}`, "valid-"+ `${name}`);
      setError(error => {
        return {...error, ...{[name]: {isValid: true, value: val, errorMsg: ''}}}
      });
    }
  }

  const toggleModal = () => {
    setShow(!show);
    //Add class to body for overlay
    if (document.getElementById("main").classList.contains('modal-open')) {
      document.getElementById("main").classList.remove('modal-open');
    } else {
      document.getElementById("main").classList.add('modal-open');
    }
  }


  const sendAccountList = () => {
    setAccountList(list => {
      return {...list, clicked: !list.clicked}
    });
  }

  const organizationNameCheck = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    SendAction({action:'input_'+name, value:val, userSession:state.user_session});
    setTouched(touched => {
      return{...touched, ...{[name]: false}}
    });
    if(val === '') {
      setError(error => {
        return {...error, ...{[name]: {isValid: true, val: '',errorMsg: ''}}}
      });
    }
    else if(!val.match(regExp.organization)) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, val: '',errorMsg: t('regExpr.' + name)}}}
      });
    } else {
      setError(error => {
        return {...error, ...{[name]: {isValid: true, val: val,errorMsg: ''}}}
      });
    }
  }

  const closeModal = () => {
    setShow(!show);
    const urlParams = new URLSearchParams(window.location.search);
    let queryString = urlParams.delete('verify_email');
    queryString = urlParams.toString();
    window.location = new URL(window.location.href.split("?")[0] + '?' + queryString);
    SendAction({action:'POST createAccount API failed', value: 'Reload signup page', userSession: state.user_session});
    //Add class to body for overlay
    if (document.getElementById("main").classList.contains('modal-open')) {
      document.getElementById("main").classList.remove('modal-open');
    } else {
      document.getElementById("main").classList.add('modal-open');
    }
  }

  const closeBannerModal = () => {
    dispatch({
      type:'UPDATE_SHOW_BANNER',
      payload: !state.showBanner
    });
    //Add class to body for overlay
    if (document.getElementById("main").classList.contains('modal-open')) {
      document.getElementById("main").classList.remove('modal-open');
    } else {
      document.getElementById("main").classList.add('modal-open');
    }
  }

  const verifyEmail = (e) => {
    navTrack("oci-signup",state.language, "s1-clicked-verify-my-email-button", "send-link-api-called");
    SendAction({action: 'User clicked Verify my email button', value: 'GET SendSecurityLink API called', userSession: state.user_session})
    SendLogs({severity: '20000', message: 'User clicked Verify my email button, EmailID: '+state.username, userSession: state.user_session});

    let val = state.username;
    const name = 'email';
    const translatedName = t('signup.'+name);
    const pattern = regExp.email;
    if(val.length === 0) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: <Trans i18nKey='personalInfo.requiredMsg'>A value for {translatedName} is required.</Trans>}}}
      });
    } else if(!val.match(pattern) || val === '') {
      navTrack("oci-signup", state.language, "s1-entered-" + `${name}`, "invalid-"+ `${name}`);
      SendLogs({severity: '40000', message: 'User entered invalid email, EmailID: '+state.username, userSession: state.user_session});
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: t('regExpr.email') }}}
      });
    } else {
      navTrack("oci-signup", state.language, "s1-entered-" + `${name}`, "valid-"+ `${name}`);
      SendLogs({severity: '20000', message: 'User entered valid email, EmailID: '+state.username, userSession: state.user_session});
      const plusIndex = val.indexOf('+');
      const domainIndex = val.indexOf('@');
      if(plusIndex !== -1) {
        val = val.substring(0, plusIndex) + val.substring(domainIndex, val.length);
        dispatch({type: 'UPDATE_NAME', payload: val});
        setTaggedEmailInfo(t('signup.taggedEmailInfo'));
      }
      setError(error => {
        return {...error, ...{[name]: {isValid: true, value: val, errorMsg: ''}}}
      });
    }
    
    setVerifyEmailBtnClicked(verifyEmailBtnClicked + 1);
  }

  React.useEffect (() => {
    if(sendEmail === true && verifyEmailCount <= 3) {
      setLoading(true);
      fetch(
        `${base_url}/email/sendSecurityLink`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            'email': state.username,
            'country': state.country,
            'firstName': state.firstName,
            'lastName': state.lastName,
            'programType': _.toUpper(programType),
            'sourceType': sourceType,
            'defaultValues': state.defaultValues === 'null' ? '' : state.defaultValues,
            'userSessionId': state.user_session
          })
        }
      ).then(async res => {
        setLoading(false);
        if(res.status === 200) {
          setCounter(115);
          SendMetrics({name: 'SendEmail.Count.Metrics.Success', value:1, userSession: state.user_session});
          SendLogs({severity: 20000, message: "GET SendSecurityLink API successful, EmailID: " + state.username, userSession:state.user_session});
          navTrack("oci-signup", state.language, "s1-verification-link-sent", "email-sent");
        } else if(res.status >= 400) {
          SendMetrics({name: 'SendEmail.Count.Metrics.Error', value:1, userSession: state.user_session});
          SendLogs({severity: 20000, message: "GET SendSecurityLink API failure, EmailID: " + state.username, userSession:state.user_session});
          dispatch({
            type: 'SEND_EMAIL',
            payload: false
          });
          setError(error => {
            return {...error, ...{email: {isValid: false, val: '',errorMsg: 'Email configuration error.'}}}
          });
        }
        SendMetrics({name: 'SendEmail.Count.Metrics', value:1, userSession: state.user_session});
        
      })
    }

  }, [verifyEmailCount])

  return (
    <div>
    {state.nextStep ? <></> : 
    <div className="contentContainer">
      <div className="upperContentContainer">
      {state.apiError && <Notifier type="error" message={t('signup.apiError')} position='apiError' />}
      <RedwoodModal onClose={e=> closeBannerModal()} show={state.showBanner} buttonName={bannerLevel !== "error"? "Close" : "" }>
      <div >
        <Icon name={bannerLevel}/>
        {bannerTitle}
      </div>
      <div>
      <h3>{bannerMessage}</h3>
      </div>
      </RedwoodModal>
      <RedwoodModal onClose={e=> closeModal()} title={t('emailVerification.failureTitle')} show={show} buttonName="Retry">
        <p>{t('emailVerification.failureText')}</p>
        <p>{t('emailVerification.failureText1')}</p>
      </RedwoodModal>
        <form autoComplete="off">
        <div className="title6">{t('signup.accountInformation', 'Account information')}</div>
          <RedwoodSelect
            label={t('signup.country', 'Country/Territory')}
            name="country"
            required
            value={state.countryObject}
            disabled={(!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.country)) || !_.isEmpty(state.emailToken) ||  !_.isEmpty(verifyEmailToken) ? true : false}
            data={countriesList()}
            error={invalid}
            errorMsg={<Trans i18nKey="signup.countryError"> Contact Sales Self-service for your country is currently unavailable; please contact <a href="https://www.oracle.com/corporate/contact/global.html#americas" target='_blank' >Oracle Sales</a>
            to assist you.</Trans>}
            onChange={e => {
              SendMetrics({name: 'Country.Selection.Count.Metrics', value:1, userSession: state.user_session});
              SendAction({action:'input_country', value:e.value, userSession:state.user_session});
              const countryInfo = countries.countries[e.value];
              if(countryInfo === undefined) {
                setInvalid(true)
                dispatch({
                  type: 'UPDATE_COUNTRY',
                  payload: ['', e, {}, '', '']
                });
              } else {
                const orgId = getOrgId(countryInfo.tc.OrgName);
                setInvalid(false)
                dispatch({
                  type: 'UPDATE_COUNTRY',
                  payload: [e.value, e, countryInfo, orgId]
                });
              }
              
            }}
            onBlur ={e => {
              navTrack("oci-signup",state.language, "s1-selected-country", state.country);
            }}
          />
        
        <div className="row">
          <div className="col-md-6 col-xs-12"> 
            <RedwoodInputText type="text" 
              placeholder={t('signup.firstNamePlaceholder')}
              label={t('signup.firstName', 'First Name')}
              disabled={(!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.firstName)) || !_.isEmpty(state.emailToken) ? true : false}
              name="firstName" 
              value={state.firstName} 
              required 
              error={error.firstName.errorMsg}
              valid={error.firstName.isValid}
              onChange={e => onChangeHandler(e, 'UPDATE_FIRST_NAME', e.target.value)}
              onBlur={e => {onBlurHandler(e, regExp.personName, 'UPDATE_FIRST_NAME');}}
            />
          </div> 
          <div className="col-md-6 col-xs-12"> 
            <RedwoodInputText type="text" 
              placeholder={t('signup.lastNamePlaceholder')}
              label={t('signup.lastName', 'Last Name')}
              disabled={(!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.lastName)) || !_.isEmpty(state.emailToken) ? true : false}
              name="lastName" 
              value={state.lastName} 
              required 
              error={error.lastName.errorMsg}
              valid={error.lastName.isValid}
              onChange={e => onChangeHandler(e, 'UPDATE_LAST_NAME', e.target.value)}
              onBlur={e => onBlurHandler(e, regExp.personName, 'UPDATE_LAST_NAME')}
            />
          </div>
        </div>
        
        <RedwoodInputText type="text"
          placeholder={t('signup.emailPlaceholder')}
          label={t('signup.email', 'Email')}
          name="email"
          disabled={!_.isEmpty(state.selectedPromo) || !_.isEmpty(state.emailToken) ? true : false}
          required
          value={state.username}
          valid={error.email.isValid}
          error={error.email.errorMsg}
          info={_.isEmpty(taggedEmailInfo) ? true : false}
          infoMsg={taggedEmailInfo}
          onChange={e => {onEmailChange(e, "UPDATE_NAME", e.target.value, regExp.email);
          setAccountList(list => {
            return {...list, ...{exist: false, clicked: false, status: false}}
          });    
                
          }}
        />

        {!state.sendEmail && <Notifier type='error' message='Email verification link failed to send' position='sendEmailFailure' />}
        {accountList.exist && !accountList.status && 
          <Notifier type="warning" position="email" message={t('signup.forgotAcctEmail3')} closeButton={true} action={sendAccountList}/>
        }
        {accountList.status &&
          <Notifier type="greenCheck" position="normal" message={t('signup.requestSent')} detail={t('signup.forgotAcctEmail4')} />
        }
        
        <PromoDialog email={error.email} updateEmailError={updateEmailError} updateAccountListing={updateAccountListing} updateAccountName={updateAccountName} updateSETrialAccountName={updateSETrialAccountName} resetError={resetError} emailVerification={emailVerification} verifyEmailBtnClicked={verifyEmailBtnClicked} sendVerificationLink={sendVerificationLink}/>
        

        {!(counter === 0) && !state.validateEmail && <Notifier type='info' position='emailVerificationTimer' message={t('signup.emailVerifyLinkSent','Email verification link sent')} emailTimer={timer(counter)} count={3 - verifyEmailCount}/>}
        {verifyEmailCount === 3 && counter === 0 && maxAttemptsError && <Notifier type='error' position='emailMaxAttemptsError' message={t('emailVerification.emailMaxAttemptsTitle')}/>}
        {counter === 0 && (_.isEmpty(state.emailToken) && state.validateEmail === false) && <Button type='solid'  disabled={!state.sendEmail || state.counter === 0 ? true: canVerifyEmail()} onClick={e => verifyEmail(e)} text={t('signup.verifyMyEmail','Verify my email')} loading={verifyEmailLoading || loading}/>}

        {(state.validateEmail === true  || !_.isEmpty(state.emailToken) ) &&
        <>

        <PasswordComponent updateTouched={updateTouched} updatePasswordErrorFlag={passwordErrorFlag} passwordError={passwordError}/>

        <div className='row'>
        <div className={(state.country === 'JP' || state.country === 'CN' || state.country === 'TW' || state.country === 'KR') ? 'col-md-6' : 'col-xs-12'}>
        <RedwoodInputText type="text" 
          placeholder={t('signup.organizationPlaceholder')}
          label={t('signup.organization', 'Company Name') }
          disabled={!_.isEmpty(state.selectedPromo) && !_.isEmpty(state.selectedPromo.customerName) ? true : false}
          name="organization" 
          value={state.companyName} 
          onChange={e => {
            onChangeHandler(e, 'UPDATE_ORG', e.target.value);
            if(e.target.value !== "") {
              dispatch({
                type: 'UPDATE_USE',
                payload: 'COMPANY'
              });
            } else {
              dispatch({
                type: 'UPDATE_USE',
                payload: 'PERSONAL'
              });
            }
          }}
          onBlur={e => organizationNameCheck(e)}
        />
        </div>

        {(state.country === 'JP' || state.country === 'CN' || state.country === 'TW' || state.country === 'KR') && 
        <div className="col-md-6 col-xs-12">
        <RedwoodInputText type="text" 
          placeholder={t('signup.altEngCompanyNamePlaceholder', 'Enter alternate english company name')}
          label={t('signup.altEngCompanyName', 'Alternate English Company Name') }
          name="altEnglishCompanyName" 
          value={state.altEnglishCompanyName} 
          required={state.companyName !==''? true : false}
          onChange={e => {
            onChangeHandler(e, 'UPDATE_AlT_COMPANY_NAME', e.target.value);
          }}
          onBlur={e => {onBlurHandler(e, regExp.altEnglishCompanyName, 'UPDATE_AlT_COMPANY_NAME')}}
        />
        </div>
        }
        </div>

        <div className='row'>
        {state.country === 'JP' && 
        <div className="col-md-6 col-xs-12">
        <RedwoodInputText type="text" 
          placeholder={t('signup.departmentNamePlaceholder', 'Enter your Department')}
          required
          label={t('signup.departmentName', 'Department Name') }
          name="departmentName" 
          value={state.departmentName} 
          onChange={e => {
            onChangeHandler(e, 'UPDATE_DEPT_NAME', e.target.value);
          }}
          onBlur={e => onBlurHandler(e, '.*', 'UPDATE_DEPT_NAME')}
        />
        </div>
        }

        {state.country === 'JP' &&
        <div className="col-md-6 col-xs-12">
        <RedwoodInputText type="text" 
          placeholder={t('signup.jobTitlePlaceholder', 'Enter your job title')}
          label={t('signup.jobTitle', 'Job Title') }
          name="jobTitle" 
          value={state.jobTitle} 
          onChange={e => {
            onChangeHandler(e, 'UPDATE_JOB_TITLE', e.target.value);
          }}
          onBlur={e => onBlurHandler(e, '.*', 'UPDATE_JOB_TITLE')}
        />
        </div>
        }
        </div>

        <RedwoodInputText type="text"
          placeholder={t('signup.accountNamePlaceholder')}
          label={t('signup.accountName')}
          name="accountName"
          required
          value={state.accountName}
          valid={error.accountName.isValid}
          error={error.accountName.errorMsg}
          info={!error.accountName.isValid}
          infoMsg={<Trans i18nKey="signup.accountNameInfo"> This will be assigned to your company's or organization's environment when 
          signing into the Console. You can always <a href="https://docs.cloud.oracle.com/en-us/iaas/Content/General/Concepts/renamecloudaccount.htm?Highlight=rename%20cloud%20account" target='_blank' rel="noopener noreferrer">rename</a>
          it later from the Console.</Trans>}
          onChange={e => onChangeHandler(e, "UPDATE_ACC_NAME", e.target.value.toLowerCase())}
          onBlur={e => onBlurHandler(e, regExp.identityDomainName, "UPDATE_ACC_NAME")}
        />
        <RedwoodSelect
          placeholder={t('signup.homeRegionPlaceholder')}
          label={t('signup.homeRegion')}
          name="homeRegion"
          required
          value={state.homeRegion}
          data={state.homeRegions}
          info={true}
          infoMsg={<Trans i18nKey="signup.homeRegionInfo">Your <a href="https://docs.cloud.oracle.com/en-us/iaas/Content/Identity/Tasks/managingregions.htm?Highlight=home%20region#The" target='_blank' rel="noopener noreferrer">home region </a> is the geographic location where your account and identity resources will be created. 
          It is not changeable after sign-up. <a href="https://www.oracle.com/cloud/data-regions.html#northamerica" target='_blank' rel="noopener noreferrer">See Regions</a> for service availability.</Trans>}
          onChange={e => {
            SendAction({action:'input_homeRegion', value:e.value.id, userSession:state.user_session});
            dispatch({
              type:`UPDATE_HOME_REGION`,
              payload: e
            });
          }}
          onBlur ={e => { if (state.homeRegion !== null) { 
            navTrack("oci-signup",state.language, "s1-selected-home-region", state.homeRegion.value.id)
          }
        }}
        />
        </>
        }
      </form>
      </div>
      <TermsOfUseComponent status={canContinue()}/>
    </div>}

    </div>
  )
}

export default SignUpFormContainer;
